import { t } from "@/i18n-js/instance";
import { isSnippetTypeAFile } from "@/react/components/SettingsApp/CommunityBot/utilities";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import {
  dateFormats,
  formattedDateTime,
} from "@/react/helpers/dateTimeHelpers/formattedDateTime";
import { TypeBadge } from "@/react/pages/BotBuilder/KnowledgePage/TypeBadge";
import type { SnippetPreview } from "../snippetsQueries";

export const ResourceDetails = ({ snippet }: { snippet: SnippetPreview }) => {
  const isFile = isSnippetTypeAFile(String(snippet?.type));

  return (
    <div className="flex w-full flex-col gap-4 pb-6">
      <div className="flex flex-row gap-2">
        <div className="w-36 shrink-0">
          <Typography.LabelSm>
            {t(
              "settings.community_bot.knowledge.custom.preview_drawer.details_section.name",
            )}
          </Typography.LabelSm>
        </div>
        <div
          className="flex-1"
          style={{
            wordBreak: "break-word",
            wordWrap: "break-word",
            overflowWrap: "break-word",
          }}
        >
          <Typography.LabelSm weight="semibold">
            {snippet.title}
          </Typography.LabelSm>
        </div>
      </div>
      <div className="flex flex-row gap-2">
        <div className="w-full">
          <Typography.LabelSm>
            {t(
              "settings.community_bot.knowledge.custom.preview_drawer.details_section.type",
            )}
          </Typography.LabelSm>
        </div>
        <div className="w-full">
          <TypeBadge type={snippet.type} />
        </div>
      </div>
      {isFile && (
        <div className="flex flex-row gap-2">
          <div className="w-full">
            <Typography.LabelSm>
              {t(
                "settings.community_bot.knowledge.custom.preview_drawer.details_section.size",
              )}
            </Typography.LabelSm>
          </div>
          <div className="w-full">
            <Typography.LabelSm weight="semibold">
              {snippet.file_size}
            </Typography.LabelSm>
          </div>
        </div>
      )}
      <div className="flex flex-row gap-2">
        <div className="w-full">
          <Typography.LabelSm>
            {t(
              "settings.community_bot.knowledge.custom.preview_drawer.details_section.used_in_replies",
            )}
          </Typography.LabelSm>
        </div>
        <div className="w-full">
          <Typography.LabelSm weight="semibold">
            {snippet.used_in_replies}
          </Typography.LabelSm>
        </div>
      </div>
      <div className="flex flex-row gap-2">
        <div className="w-full">
          <Typography.LabelSm>
            {t(
              "settings.community_bot.knowledge.custom.preview_drawer.details_section.created",
            )}
          </Typography.LabelSm>
        </div>
        <div className="w-full">
          <Typography.LabelSm weight="semibold">
            {formattedDateTime({
              dateTime: new Date(snippet.created_at),
              format: dateFormats.long_date,
            })}
          </Typography.LabelSm>
        </div>
      </div>
      {snippet.creator && (
        <div className="flex flex-row gap-2">
          <div className="w-full">
            <Typography.LabelSm>
              {t(
                "settings.community_bot.knowledge.custom.preview_drawer.details_section.created_by",
              )}
            </Typography.LabelSm>
          </div>
          <div className="w-full">
            <div className="flex items-center gap-2">
              <UserImageWithFallback
                name={snippet.creator.name}
                src={snippet.creator.avatar_url}
                size="5"
                isFullRounded
              />
              <Typography.LabelSm weight="semibold">
                {snippet.creator.name}
              </Typography.LabelSm>
            </div>
          </div>
        </div>
      )}
      {!isFile && (
        <div className="flex flex-row gap-2">
          <div className="w-full">
            <Typography.LabelSm>
              {t(
                "settings.community_bot.knowledge.custom.preview_drawer.details_section.last_updated",
              )}
            </Typography.LabelSm>
          </div>
          <div className="w-full">
            <Typography.LabelSm weight="semibold">
              {formattedDateTime({
                dateTime: new Date(snippet.updated_at),
                format: dateFormats.long_date,
              })}
            </Typography.LabelSm>
          </div>
        </div>
      )}
      {!isFile && snippet.updater && (
        <div className="flex flex-row gap-2">
          <div className="w-full">
            <Typography.LabelSm>
              {t(
                "settings.community_bot.knowledge.custom.preview_drawer.details_section.updated_by",
              )}
            </Typography.LabelSm>
          </div>
          <div className="w-full">
            <div className="flex items-center gap-2">
              <UserImageWithFallback
                name={snippet.updater.name}
                src={snippet.updater.avatar_url}
                size="5"
                isFullRounded
              />
              <Typography.LabelSm weight="semibold">
                {snippet.updater.name}
              </Typography.LabelSm>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
